module.exports = __webpack_public_path__ + "static/media/Calculator.36517dd6.svg";